import { Tag, Tooltip } from "antd";
import { fmtFechaHora } from "./AtencionBarraSuperior";

// AUDITORIA-CLINICA-REDISENO (FASE 1 · bloque B) -- franja de identificación.
// Sustituye a la tabla vertical de 6 filas del drawer actual (media pantalla
// para 6 datos) por un grid de 12 columnas en dos filas.
//
// Cobertura/aseguradora/plan NO vienen en `GET /audit/clinical/appointments/
// :idcita` (sólo en la fila del listado, ver FASE 0 §4): llegan por
// `location.state.fila` cuando se entra desde la lista. Si se abre la URL
// directamente no se inventan -- se muestran como "—".
const COBERTURA_TAG = {
    SEGURO: { color: "blue", label: "Seguro" },
    PARTICULAR: { color: "green", label: "Particular" },
    SIN_DETERMINAR: { color: "default", label: "Sin determinar" },
};

const Campo = ({ etiqueta, valor, span, mono, children }) => {
    const texto = valor === null || valor === undefined || valor === "" ? "—" : String(valor);
    return (
        <div className={`ac-campo ac-span-${span}`}>
            <span className="ac-etiqueta">{etiqueta}</span>
            {children ? (
                <span className="ac-campo__valor">{children}</span>
            ) : (
                <Tooltip title={texto.length > 24 ? texto : null}>
                    <span className={`ac-campo__valor${mono ? " ac-mono" : ""}`}>{texto}</span>
                </Tooltip>
            )}
        </div>
    );
};

function AtencionIdentificacion({ detalle, fila }) {
    const cobertura = fila?.tipo_cobertura || null;
    const coberturaTag = cobertura ? COBERTURA_TAG[cobertura] || { color: "default", label: cobertura } : null;
    // No existe "auditor asignado" en el modelo (FASE 0 §6): lo más cercano y
    // real es quién inició la revisión (`clinical_audit_reviews.started_by`).
    const iniciadaPor = detalle?.estado_auditoria?.started_by?.full_name || null;

    return (
        <div className="ac-identificacion" data-testid="ac-identificacion">
            <Campo etiqueta="Paciente" span={3} valor={detalle?.paciente?.nombres_completos} />
            <Campo etiqueta="Documento" span={2} mono valor={detalle?.paciente?.cedula} />
            <Campo etiqueta="Médico tratante" span={3} valor={detalle?.doctor?.nombre} />
            <Campo etiqueta="Clínica" span={2} valor={detalle?.clinica?.nombre} />
            <Campo etiqueta="Fecha de atención" span={2} valor={detalle?.fecha ? fmtFechaHora(detalle.fecha) : null} />

            <Campo etiqueta="Cobertura" span={3}>
                {coberturaTag ? <Tag color={coberturaTag.color}>{coberturaTag.label}</Tag> : "—"}
            </Campo>
            <Campo etiqueta="Aseguradora" span={2} valor={fila?.aseguradora} />
            <Campo etiqueta="Plan" span={4} valor={fila?.plan} />
            <Campo etiqueta="Revisión iniciada por" span={3} valor={iniciadaPor} />
        </div>
    );
}

export default AtencionIdentificacion;
